<template>
  <div class="layout-user-person-info"
       v-loading="loading"
       element-loading-text="个人信息加载中，请稍等...">
    <AppScrollbar style="height: 100%" v-if="personInfo">
      <el-form class="theme-light-bg theme-border"
               label-width="120px"
               label-suffix="：">
        <el-form-item label="登录账户">
          <span>{{personInfo.loginId}}</span>
        </el-form-item>
        <el-form-item label="账户姓名">
          <span>{{personInfo.trueName}}</span>
        </el-form-item>
        <el-form-item label="所属角色">
          <span>{{personInfo.roleName || '未知角色'}}</span>
        </el-form-item>
        <el-form-item label="创建时间" v-if="personInfo.createDate">
          <span>{{personInfo.createDate}}</span>
        </el-form-item>
      </el-form>
    </AppScrollbar>
  </div>
</template>

<script>
import AppScrollbar from '../elements/AppScrollbar'

export default {
  name: 'UserPersonInfo',
  components: {AppScrollbar},
  data () {
    return {
      loading: false,
      personInfo: null
    }
  },
  methods: {
    loadPersonInfo () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/center/personInfo',
        method: 'post',
        disableErrorPage: true
      }).then((response) => {
        if (response.data) {
          this.personInfo = response.data['personInfo']
        }
      }, () => {
        this.$message.error({
          message: '请求发送失败，请稍后重试',
          center: true
        })
      }).finally(() => {
        this.loading = false
      })
    }
  },
  mounted () {
    this.loadPersonInfo()
  }
}
</script>

<style lang="scss">
  .layout-user-person-info {
    height: 100%;
    background-color: #fff;
    padding: 15px;
    .el-form {
      padding-top: 15px;
      border: 1px solid;
      & > .el-form-item {
        margin-bottom: 10px;
        &:last-child {
          margin-bottom: 15px;
        }
        .el-form-item__label {
          color: #909399;
          font-size: 12px;
        }
        .el-form-item__content {
          color: #303133;
          font-size: 12px;
        }
      }
    }
  }
</style>
